// 资产台账
import request from '@/api/request'

export function fetchData() {
    return request({
        url: '/model-analysis/asset/material/sumValueByMonth',
        // params,
    })
}